import React, { useContext, useState } from 'react';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import { modalContext } from '@/context/modal.context';
import { UserContext } from '@/components/pages/assessments/context/user.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@/components/Button/Button';

const AssessmentActions = ({ buttonLabels = {}, enableNext, selection, handleNext }) => {
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const { goBack, handleRestart, metadata, reviewing, hasPreviousStep } = useContext(stepContext);
  const { user, agencyClient } = useContext(UserContext);
  const modal = useContext(modalContext);
  const buttons = Object.assign(buttonLabels, metadata?.ui?.buttons || {});

  const handleRestartClick = () => {
    modal.enqueueModal({
      name: 'ConfirmationModal',
      title: (() => (
        <>
          <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className={css('modal-exclamation-icon')} /> &nbsp;{t('Are you sure?')}
        </>
      ))(),
      text: t('Are you sure you want to leave this page and lose your work?'),
      onConfirm: () => handleRestart()
    });
  };

  return (
    <Row>
      <Col xs={12} md={8} className="text-start">
        {!reviewing && hasPreviousStep && (
          <Button
            additionalClasses={`${css('action-btn')}`}
            type="secondary"
            shape="pill"
            icon={{ style: 'fas', font: 'chevron-left', position: 'left' }}
            text={t(buttons.back || 'Previous page')}
            onButtonClick={goBack}
          />
        )}
        {!reviewing && agencyClient && !!user?.is_professional && (
          <Button
            additionalClasses={`${css('action-btn')}`}
            type="secondary"
            shape="pill"
            icon={{ style: 'fas', font: 'refresh', position: 'left' }}
            text={t(buttons.exit || 'Restart')}
            onButtonClick={handleRestartClick}
          />
        )}
      </Col>
      <Col xs={12} md={4} className="text-end">
        {!reviewing && (
          <Button
            additionalClasses={`${css('action-btn')}`}
            state={!enableNext ? 'disabled' : null}
            type="primary"
            shape="pill"
            icon={{ style: 'fas', font: 'chevron-right', position: 'right' }}
            text={t(buttons.next || 'Next page')}
            onButtonClick={() => handleNext(selection)}
          />
        )}
        {reviewing && (
          <Button
            additionalClasses={`${css('action-btn')}`}
            state={!enableNext ? 'disabled' : null}
            type="primary"
            shape="pill"
            icon={{ style: 'fas', font: 'chevron-right', position: 'right' }}
            text={t(buttons.update || 'Update')}
            onButtonClick={() => handleNext(selection)}
          />
        )}
      </Col>
    </Row>
  );
};

export default AssessmentActions;
